/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tier2Model
 */
export interface Tier2Model {
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Tier2Model
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    tier2Status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Tier2Model
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Tier2Model
     */
    fileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    fileGUID?: string;
    /**
     * 
     * @type {number}
     * @memberof Tier2Model
     */
    newRateReliefAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof Tier2Model
     */
    note?: string | null;
}

/**
 * Check if a given object implements the Tier2Model interface.
 */
export function instanceOfTier2Model(value: object): value is Tier2Model {
    return true;
}

export function Tier2ModelFromJSON(json: any): Tier2Model {
    return Tier2ModelFromJSONTyped(json, false);
}

export function Tier2ModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier2Model {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'tier2Status': json['tier2Status'] == null ? undefined : json['tier2Status'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
        'fileGUID': json['fileGUID'] == null ? undefined : json['fileGUID'],
        'newRateReliefAmount': json['newRateReliefAmount'] == null ? undefined : json['newRateReliefAmount'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function Tier2ModelToJSON(json: any): Tier2Model {
    return Tier2ModelToJSONTyped(json, false);
}

export function Tier2ModelToJSONTyped(value?: Tier2Model | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'tier2Status': value['tier2Status'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'fileName': value['fileName'],
        'fileSize': value['fileSize'],
        'fileGUID': value['fileGUID'],
        'newRateReliefAmount': value['newRateReliefAmount'],
        'note': value['note'],
    };
}

